export default __webpack_public_path__ + "static/media/logo-app2i.bf30e447.svg";